// Shareable reading lists. The list lives entirely in the link
// (/shared?ids=a,b,c&name=…): nothing is stored on a server, there are no
// writes, and opening the link reads only the listed (published) stories.

export const SHARED_LIST_MAX = 100;
const ID = /^[a-z0-9][a-z0-9_-]{0,127}$/;

export interface SharedList {
  ids: string[];
  name: string;
}

export function sharedListPath(ids: string[], name = ""): string {
  const q = new URLSearchParams({ ids: [...new Set(ids)].filter((id) => ID.test(id)).slice(0, SHARED_LIST_MAX).join(",") });
  const n = name.trim().slice(0, 80);
  if (n) q.set("name", n);
  return `/shared?${q.toString().replace(/%2C/g, ",")}`;
}

/** Parses and validates a shared-list query string; unknown or malformed IDs are dropped. */
export function parseSharedList(search: string): SharedList {
  const q = new URLSearchParams(search);
  const ids = [...new Set((q.get("ids") ?? "").split(",").map((s) => s.trim()).filter((id) => ID.test(id)))].slice(0, SHARED_LIST_MAX);
  return { ids, name: (q.get("name") ?? "").trim().slice(0, 80) };
}
